// Close the dropdown if the user clicks outside of it
window.onclick = function(event) {
  var dropdown = document.getElementsByClassName("open-categories");
  var cl =  dropdown[0].classList;
  if (event.target.matches('.open-categories')) {
    cl.toggle('categories-open');
  } else {
    if (cl.contains('categories-open')) {
      cl.remove('categories-open');
    }
  }
}